import React, { memo, useCallback } from 'react';
import Links from 'utils/links';
import { CardView, HelpCallToAction } from 'design-system';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import { selectHasSpaces } from 'features/spaces/reducers/selectors';
const BankLoginsHelp = () => {
    const navigation = useMainStackNavigation();
    const hasSpaces = useAppSelector(selectHasSpaces);
    const onHelpPress = useCallback(() => {
        Links.openKnownLink('bankLoginsHelp');
    }, []);
    const onFindAccounts = useCallback(() => {
        navigation.navigateDeprecated('FindSpaceAccounts');
    }, []);
    return (<CardView noMarginTop noMarginBottom>
      {hasSpaces ? (<HelpCallToAction onDark alt onPress={onFindAccounts} subTitle="See which Spaces they’re in" title="Can’t find your accounts?"/>) : null}
      <HelpCallToAction onDark alt onPress={onHelpPress} subTitle="Learn how to do it" title="Need to amend your accounts?"/>
    </CardView>);
};
export default memo(BankLoginsHelp);
